export const modelNameMap = {
  "aible-constrained-25": "Aible-NN-CL-1-25",
  "aible-constrained-50": "Aible-NN-CL-1-50",
  "aible-constrained-75": "Aible-NN-CL-1-75",
  "aible-relative-impact": "Aible-NN-CL-1-0",
  "simple-neural-net": "Simple-NN-CL",
  "aible-impact-regressor-hu": "Aible-NN-RG-1",
  "aible-impact-regressor": "Aible-NN-RG-2",
  "ada-boost-impact": "Aible-Ada-Boost-CL",
  "ada-boost-r": "Ada-Boost-CL",
  "decision-tree-r": "Decision-Tree-CL",
  "gaussian-naive-bayes-r": "Gaussian-Naive-Bayes-CL",
  "gradient-boosting-r": "Gradient-Boosting-CL",
  "logistic-regression-r": "Logistic-Regression-CL",
  "random-forest-r": "Random-Forest-CL",
  "extra-trees-regressor": "Extra-Trees-RG",
  "extra-trees-regressor-impact": "Aible-Extra-Trees-RG",
  "linear-elasticnet": "Linear-Elasticnet-RG",
  "linear-model-lasso": "Linear-Lasso-RG",
  "linear-model-ridge": "Linear-Ridge-RG",
  "random-forest-regressor": "Random-Forest-RG",
  "aible-ss-reg-1-0": "Aible-Bayes-RG-1",
  "aible-ss-reg-2-0": "Aible-Bayes-RG-2",
  "aible-ss-lpm-1-0": "Aible-Bayes-CL-1",
  "aible-ss-lpm-2-0": "Aible-Bayes-CL-2",
  "aible-flex-0": "Aible-NN-CL-2-0",
  "aible-flex-2": "Aible-NN-CL-2-2",
  "aible-flex-5": "Aible-NN-CL-2-5",
  "aible-flex-10": "Aible-NN-CL-2-10",
  "aible-flex-20": "Aible-NN-CL-2-20",
  "aible-flex-30": "Aible-NN-CL-2-30",
  "aible-flex-40": "Aible-NN-CL-2-40",
  "aible-flex-50": "Aible-NN-CL-2-50",
  "aible-flex-60": "Aible-NN-CL-2-60",
  "aible-flex-70": "Aible-NN-CL-2-70",
  "aible-flex-80": "Aible-NN-CL-2-80",
  "aible-flex-90": "Aible-NN-CL-2-90",
  "aible-flex-n2": "Aible-NN-CL-2-n2",
  "aible-flex-n5": "Aible-NN-CL-2-n5",
  "aible-frontier1-0": "Aible-NN-CL-3-0",
  "aible-frontier1-2": "Aible-NN-CL-3-2",
  "aible-frontier1-5": "Aible-NN-CL-3-5",
  "aible-frontier1-10": "Aible-NN-CL-3-10",
  "aible-frontier1-20": "Aible-NN-CL-3-20",
  "aible-frontier1-30": "Aible-NN-CL-3-30",
  "aible-frontier1-40": "Aible-NN-CL-3-40",
  "aible-frontier1-50": "Aible-NN-CL-3-50",
  "aible-frontier1-60": "Aible-NN-CL-3-60",
  "aible-frontier1-70": "Aible-NN-CL-3-70",
  "aible-frontier1-80": "Aible-NN-CL-3-80",
  "aible-frontier1-90": "Aible-NN-CL-3-90",
  "aible-frontier2-0": "Aible-NN-CL-4-0",
  "aible-frontier2-2": "Aible-NN-CL-4-2",
  "aible-frontier2-5": "Aible-NN-CL-4-5",
  "aible-frontier2-10": "Aible-NN-CL-4-10",
  "aible-frontier2-20": "Aible-NN-CL-4-20",
  "aible-frontier2-30": "Aible-NN-CL-4-30",
  "aible-frontier2-40": "Aible-NN-CL-4-40",
  "aible-frontier2-50": "Aible-NN-CL-4-50",
  "aible-frontier2-60": "Aible-NN-CL-4-60",
  "aible-frontier2-70": "Aible-NN-CL-4-70",
  "aible-frontier2-80": "Aible-NN-CL-4-80",
  "aible-frontier2-90": "Aible-NN-CL-4-90",
  "aible-rgx1-100": "Aible-NN-RG-3-100",
  "aible-rgx1-75": "Aible-NN-RG-3-75",
  "aible-rgx1-50": "Aible-NN-RG-3-50",
  "aible-rgx1-125": "Aible-NN-RG-3-125",
  "aible-rgx2-100": "Aible-NN-RG-4-100",
  "aible-rgx2-75": "Aible-NN-RG-4-75",
  "aible-rgx2-50": "Aible-NN-RG-4-50",
  "aible-rgx2-125": "Aible-NN-RG-4-125",
  "aible-impact-regressor-1": "Aible-NN-RG-5-0",
  "aible-impact-regressor-2": "Aible-NN-RG-6-0",
  "aible-impact-regressor-3": "Aible-NN-RG-7-0",
  "aible-impact-regressor-4": "Aible-NN-RG-8-0",
  "aible-impact-regressor-5": "Aible-NN-RG-9-0",
  "aible-impact-regressor-6": "Aible-NN-RG-10-0",
  "aible-impact-regressor-7": "Aible-NN-RG-11-0",
  "aible-impact-regressor-hu-1": "Aible-NN-RG-12-0"
};
